import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'services/toast.service';
import { BaseFormModalComponent } from '../base-form-modal.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { ReadingRoomListItem, ReadingRoomListItemPagedResponse } from 'types/reading-room.interface';
import { ApiService } from 'services/api.service';
import { NgClass } from '@angular/common';
import { TooltipComponent } from 'components/tooltip/tooltip.component';
import { getControlsWithErrors, MAX_LENGTH_NAME } from 'util/form.utility';
import { BackofficeReadingRoomSubmissionCard, RedirectReadingRoomSubmissionRequest } from 'types/service.interface';

@Component({
  selector: 'app-change-reading-room-modal',
  standalone: true,
  imports: [TranslateModule, SpinnerComponent, NgClass, TooltipComponent, ReactiveFormsModule],
  templateUrl: './change-reading-room-modal.component.html',
  styleUrls: ['./change-reading-room-modal.component.scss', '../../form/base-form.scss']
})
export class ChangeReadingRoomModalComponent extends BaseFormModalComponent implements OnInit {
  public readonly maxFieldLength = MAX_LENGTH_NAME;
  @Input() isOpen!: boolean;
  @Input() application!: BackofficeReadingRoomSubmissionCard;
  @Output() update: EventEmitter<BackofficeReadingRoomSubmissionCard> = new EventEmitter<BackofficeReadingRoomSubmissionCard>();
  @ViewChild('content') content!: TemplateRef<any>;

  readingRooms: ReadingRoomListItem[] = [];
  shouldRenderTooltip = false;
  isCrudLoading = true;

  get reasonForClient(): AbstractControl<any, any> | null {
    return this.form.get('reasonForClient');
  }
  get reasonForReadingRoom(): AbstractControl<any, any> | null {
    return this.form.get('reasonForReadingRoom');
  }
  get readingRoomId(): AbstractControl<any, any> | null {
    return this.form.get('readingRoomId');
  }

  constructor(
    formBuilder: FormBuilder,
    config: NgbModalConfig,
    modalService: NgbModal,
    toastService: ToastService,
    translateService: TranslateService,
    private apiService: ApiService
  ) {
    super(formBuilder, config, modalService, toastService, translateService);
  }

  ngOnInit(): void {
    this.apiService.getReadingRoomList().subscribe((readingRoomList: ReadingRoomListItemPagedResponse) => {
      this.readingRooms = readingRoomList.list ?? [];
      this.readingRooms = this.readingRooms.filter((room) => room.id !== this.application.readingRoom.id);

      this.isCrudLoading = false;

      if (this.isOpen) {
        this.fillForm();
        this.shouldRenderTooltip = false;
        this.open(this.content);
        setTimeout(() => {
          this.shouldRenderTooltip = true;
        }, 10);
      }
    });
  }

  fillForm(): void {
    this.form = this.formBuilder.group({
      readingRoomId: [null, [Validators.required]],
      reasonForReadingRoom: ['', [Validators.required, Validators.maxLength(MAX_LENGTH_NAME)]],
      reasonForClient: ['', [Validators.required, Validators.maxLength(MAX_LENGTH_NAME)]]
    });
  }

  protected override close(): void {
    super.close();
  }

  submit(): void {
    if (this.form.valid) {
      const args: RedirectReadingRoomSubmissionRequest = {
        readingRoomSubmissionId: this.application.id,
        ...this.form.value
      };

      this.apiService.redirectSubmission(args).subscribe((updatedApplication: BackofficeReadingRoomSubmissionCard) => {
        this.toastService.showSuccess('redirectSubmissionSuccess', '', {
          shouldTranslate: true
        });
        this.close();
        this.update.emit(updatedApplication);
      });
    } else {
      this.submitAttempted = true;
      this.toastService.showFormValidationError(getControlsWithErrors(this.form), 'components.changeReadingRoom');
    }
  }
}
